export const boxShadow = {
  none: "shadow-none",
  sm: "shadow-sm",
  normal: "shadow",
  md: "shadow-md",
  lg: "shadow-lg",
  xl: "shadow-xl",
  "2xl": "shadow-2xl",
  inner: "shadow-inner",
}

export type BoxShadow = keyof typeof boxShadow
